// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-cascader-panel .el-scrollbar:first-child .el-checkbox {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
